import { Controller } from "@hotwired/stimulus"

// 予定フォームの「繰り返し」欄。選択に応じて不要な入力欄を隠す。
export default class extends Controller {
  static targets = ["scope", "rule", "preset", "custom", "frequency", "weekly", "monthly", "end", "endType", "count", "until"]
  connect() {
    this.refresh()
  }

  refresh() {
    const preset = this.hasPresetTarget ? this.presetTarget.value : "custom"
    const frequency = this.hasFrequencyTarget ? this.frequencyTarget.value : ""
    const endType = this.endTypeTargets.find((radio) => radio.checked)?.value

    // 適用範囲の選択肢があるのは編集時だけ。「この予定のみ」の間はルールを変えられない
    this.show(this.ruleTargets, !this.hasScopeTarget || this.selectedScope() !== "this")
    this.show(this.customTargets, preset === "custom")
    this.show(this.endTargets, preset !== "none")
    this.show(this.weeklyTargets, frequency === "weekly")
    this.show(this.monthlyTargets, frequency === "monthly")
    this.countTargets.forEach((input) => { input.disabled = endType !== "count" })
    this.untilTargets.forEach((input) => { input.disabled = endType !== "until" })
  }

  selectedScope() {
    return this.scopeTargets.find((radio) => radio.checked)?.value || "this"
  }

  show(elements, visible) {
    elements.forEach((element) => { element.hidden = !visible })
  }
}
